module.exports = __webpack_public_path__ + "static/media/icon-checklist.4ca553b8.svg";